import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import schema from './schema';
import { ContainerButton, PageContainer } from '../../../../../styles/styles';
import { useBeneficiarioEventual } from '../../../../../contexts/BeneficiarioEventual/context';

import FormContainer from '../../../../../components/FormContainer';
import StepProgress from '../../../../../components/StepProgress';
import Accordion from '../../../../../components/Accordion';
import Input from '../../../../../components/Inputs/Input';
import PageLoader from '../../../../../components/PageLoader';
import Button from '../../../../../components/Button';
import Alert from '../../../../../components/Alert';

import validate from '../../../../../utils/validateForm';
import steps from '../../../../../utils/steps.json';
import { cloneObject } from '../../../../../utils';
import { buscaDadosv2 } from '../../../../../services';
import { useGlobal } from '../../../../../contexts/Global/context';
import * as Styles from './styles';

function DadosCadastro() {
    const history = useHistory();
    const { dataActiveContract } = useGlobal();
    const [dataForm, setDataForm] = useState(cloneObject(schema));
    const [pageLoading, setPageLoading] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const {
        dataConsultaAtendimento,
        setDataConsultaAtendimento,
        setEmailConsulta,
        setTelefoneConsulta,
        emailConsulta,
    } = useBeneficiarioEventual();

    async function loadData() {
        setPageLoading(true);

        const dadosBeneficiario = await buscaDadosv2(
            dataConsultaAtendimento.beneficiarioEventual.numCarteira,
            dataActiveContract.numero
        );

        if (dadosBeneficiario[0]?.email) {
            setEmailConsulta(dadosBeneficiario[0]?.email);
        }

        if (dadosBeneficiario[0]?.celular?.ddd !== '' && dadosBeneficiario[0]?.celular?.numero !== '') {
            setTelefoneConsulta(dadosBeneficiario[0]?.celular?.ddd + dadosBeneficiario[0]?.celular?.numero);
        }

        const initialValues = {
            ...dataForm,
            email: {
                ...dataForm.email,
                value: dadosBeneficiario[0]?.email || '',
            },
            phoneandcellphon: {
                ...dataForm.phoneandcellphon,
                value:
                    dadosBeneficiario[0]?.celular?.ddd !== ''
                        ? `(${dadosBeneficiario[0]?.celular?.ddd}) ${dadosBeneficiario[0]?.celular?.numero}`
                        : '',
            },
        };

        setDataForm({
            ...dataForm,
            ...initialValues,
        });
        setPageLoading(false);
    }

    async function handleFowardStep() {
        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (isValid) {
            const dadosCadastro = dataForm;

            setDataConsultaAtendimento({ ...dataConsultaAtendimento, dadosCadastro });

            history.push('/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_dados_consulta');
        } else {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 300);
        }
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest,
        };

        if (event.id === 'phoneandcellphon') {
            setTelefoneConsulta(event.value);
        }

        if (event.id === 'email' && !emailConsulta) {
            setEmailConsulta(event.value);
        }

        setDataForm({
            ...dataForm,
            [id]: field,
        });
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.agendamentoConsulta} activeStep={2} />
                <Accordion title="Dados de cadastro" hasCollapse={false}>
                    <Alert
                        type={4}
                        title=""
                        message="Para seguir com o agendamento de consulta você precisa preencher os campos abaixo."
                    />
                    <FormContainer>
                        <Input field={{ ...dataForm.email }} onChange={handleChangeInput} />
                        <div>
                            <Input field={{ ...dataForm.phoneandcellphon }} onChange={handleChangeInput} />
                            {errorPhone && (
                                <Styles.SpanError>O telefone deve ter no mínimo 10 dígitos.</Styles.SpanError>
                            )}
                        </div>
                    </FormContainer>
                </Accordion>

                <ContainerButton>
                    <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                        Voltar
                    </Button>

                    <Button
                        id="continueStep"
                        type="primary"
                        onClick={() => {
                            // eslint-disable-next-line no-undef
                            if (phoneandcellphon?.value.length <= 13) {
                                setErrorPhone(true);
                            } else {
                                setErrorPhone(false);
                                handleFowardStep();
                            }
                        }}
                    >
                        Continuar
                    </Button>
                </ContainerButton>
                <PageLoader loading={pageLoading} />
            </PageContainer>
        </>
    );
}

export default DadosCadastro;
